export default "__VITE_ASSET__WR1hAJzY__"